// Phase C.7a.2 cleanup — formats a real timestamptz value (e.g.
// team_athletes.added_at, 012) for display.
//
// This is deliberately NOT the same helper used for plain `date` columns
// (like athlete_measurements.measurement_date) — those need the
// `+ 'T00:00:00'` local-midnight trick to avoid an off-by-one-day shift
// when parsed as UTC. A timestamptz string is already fully qualified
// and parses correctly on its own; appending 'T00:00:00' to one instead
// produces a malformed, unparseable string (this was the exact cause of
// "Joined Roster — Invalid Date" on RosteredAthletePage.js).
//
// Null/undefined/unparseable input renders a truthful "—", never a
// fabricated or substituted date.
export function formatTimestamp(value) {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString();
}
